




















































import { Mixins, Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import OzIcon from 'library/v4/components/oz-icon.vue'
import { IntlMixin } from 'vuemixins/intl_mixin'
import { Reaction } from '@padlet/arvo'
import { Id } from 'types'

const reaction = namespace('reaction')
const snackbars = namespace('snackbars')

@Component({ components: { OzIcon } })
export default class SurfacePostReactionStarNew extends Mixins(IntlMixin) {
  @Prop({ required: true }) postId!: Id
  @Prop({ required: true }) myReactionId!: string | undefined
  @Prop({ required: true }) isPadletColorSchemeDark!: boolean
  @Prop({ required: true }) reactionCount!: number
  @Prop({ required: true }) reactionIds!: string[]
  @Prop({ required: true }) canReact!: boolean
  @Prop({ required: true }) currentUserReacted!: boolean

  @reaction.Getter getReactionById!: (id) => Reaction | undefined
  @reaction.Getter postIdBeingReactedTo!: Id | null

  @snackbars.Action setSnackbar!: (payload: { message: string }) => void

  get isBeingReacted(): boolean {
    return !!this.postIdBeingReactedTo && Number(this.postId) === Number(this.postIdBeingReactedTo)
  }

  get myReaction(): Reaction | undefined {
    return this.myReactionId ? this.getReactionById(this.myReactionId) : undefined
  }

  get myRating(): number {
    return this.myReaction ? this.myReaction.value : 0
  }

  get title(): string {
    if (this.reactionCount === 0) {
      return this.__('Be the first one to rate this post')
    }

    let title = this.__('Avg rating: %{averageRating}', { averageRating: this.avgRating })
    if (this.myRating) {
      title += ' • ' + this.__('Your rating: %{myRating}', { myRating: this.myRating })
    }
    return title
  }

  get avgRating(): string {
    return this.reactionCount === 0 ? '0' : (this.sumRating / this.reactionCount).toFixed(1)
  }

  get sumRating(): number {
    const sumReducer = (sum: number, id): number => sum + (this.getReactionById(id) as Reaction).value
    return this.reactionIds.reduce(sumReducer, 0)
  }

  get xHalfStar(): boolean {
    if (this.reactionCount === 0) {
      return false
    }

    const avgRatingDecimalPart = parseFloat(this.avgRating) % 1
    return avgRatingDecimalPart <= 0.75 && avgRatingDecimalPart > 0.25
  }

  get fullStarRange(): number[] {
    if (this.reactionCount === 0) {
      return []
    }

    const avg = parseFloat(this.avgRating) + 0.25
    return [1, 2, 3, 4, 5].filter((starValue) => starValue < avg)
  }

  get avgRatingStarColorClass(): string {
    if (this.currentUserReacted) {
      return this.isPadletColorSchemeDark ? 'text-canary-500' : 'text-grape-500'
    } else {
      return this.isPadletColorSchemeDark ? 'text-light-text-300' : 'text-dark-text-300'
    }
  }

  showReactionOffNotice(): void {
    const message = this.__('Reactions have been disabled by the admin.')
    this.setSnackbar({ message })
  }

  startReacting(): void {
    if (this.canReact) {
      this.$emit('edit')
    } else {
      this.showReactionOffNotice()
    }
  }

  stopReacting(): void {
    this.$emit('stop-edit')
  }

  rate(value): void {
    this.$emit('create', value)
    this.stopReacting()
  }

  unrate(): void {
    this.$emit('delete')
    this.stopReacting()
  }
}
